import { Component, Inject, InjectionToken, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MessageModule } from "primeng/message";
import { HomeownerPhotoSasResponse, HomeOwnerService } from "../../services/homeowner-service";
import { LoggerService } from "../../../../shared/services/logger.service";

export const WINDOW = new InjectionToken<Window>("Window", {
  providedIn: "root",
  factory: () => window,
});

@Component({
  selector: "app-homeowner-photo-viewer",
  standalone: true,
  imports: [MessageModule],
  templateUrl: "./homeowner-photo-viewer.component.html",
  styleUrl: "./homeowner-photo-viewer.component.scss"
})
export class HomeownerPhotoViewerComponent implements OnInit {
  isLoading = true;
  downloadReady = false;
  errorMessage = "";
  errorSeverity = "error";

  private readonly guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

  constructor(
    private route: ActivatedRoute,
    private homeownerService: HomeOwnerService,
    private logger: LoggerService,
    @Inject(WINDOW) private window: Window,
  ) { }

  ngOnInit(): void {
    const assetIdentifier = this.route.snapshot.paramMap.get("assetIdentifier");

    if (!assetIdentifier || !this.guidRegex.test(assetIdentifier)) {
      this.errorMessage = "Invalid homeowner photo link.";
      this.isLoading = false;
      return;
    }

    this.homeownerService.getHomeownerPhotoSasUrl(assetIdentifier).subscribe({
      next: (response: HomeownerPhotoSasResponse) => {
        if (response.homeownerPhotoSasUrl) {
          this.window.location.href = response.homeownerPhotoSasUrl;
          this.downloadReady = true;
          this.isLoading = false;
        } else {
          this.errorMessage = "Homeowner photo URL not found.";
          this.isLoading = false;
        }
      },
      error: err => {
        this.logger.error("Error fetching homeowner photo URL", err);
        if (err.status === 404) {
          this.errorMessage = "This homeowner photo is not currently available.";
          this.errorSeverity = "warn";
        } else {
          this.errorMessage = "We're unable to retrieve this homeowner photo due to a technical issue.";
        }
        this.isLoading = false;
      },
    });
  }
}
